"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var costate_1 = require("../costate");

var useCostate_1 = __importDefault(require("./useCostate"));

var useRef = react_1.default.useRef,
    useCallback = react_1.default.useCallback,
    useEffect = react_1.default.useEffect;

function useCoreducer(coreducer, initialState) {
  var state = useCostate_1.default(initialState);
  var coreducerRef = useRef(coreducer);
  var dispatch = useCallback(function (action) {
    coreducerRef.current(costate_1.co(state), action);
  }, []);
  useEffect(function () {
    coreducerRef.current = coreducer;
  }, [coreducer]);
  return [state, dispatch];
}

exports.default = useCoreducer;